import { BaseModel } from '@ag-common-lib/lib/models/base.model';

export enum TextElementType {
  paragraph = 'paragraph',
  header1 = 'header1',
  header2 = 'header2',
  header3 = 'header3',
  header4 = 'header4',
  textLink = 'textLink',
  mouseoverLink = 'mouseoverLink',
}

export const HEADER_TEXT_TYPES = [
  TextElementType.header1,
  TextElementType.header2,
  TextElementType.header3,
  TextElementType.header4,
];

export const LINKS_TEXT_TYPES = [TextElementType.textLink, TextElementType.mouseoverLink];

export const INHERIT_FONT_COLOR = 'inherit';

export enum UnderlineStyleType {
  none = 'none',
  solid = 'solid',
  dotted = 'dotted',
  wavy = 'wavy',
}

export interface BaseTextSettings {
  fontFamily: string;
  fontSize: number;
  fontColor: string;
  backgroundColor: string;
}

export enum TextElementSchemeKeys {
  name = 'name',
  fontFamily = 'fontFamily',
  fontSize = 'fontSize',
  fontColor = 'fontColor',
  lineHeight = 'lineHeight',
  backgroundColor = 'backgroundColor',
  fontEmphasis = 'fontEmphasis',
  underlineStyle = 'underlineStyle',
}

export enum FontEmphasisType {
  bold = 'bold',
  italic = 'italic',
  underline = 'underline',
  strikethrough = 'strikethrough',
}

export enum TextAlignment {
  left = 'left',
  center = 'center',
  right = 'right',
  justify = 'justify',
}

export interface TextSettings {
  [TextElementType.paragraph]: TextElementScheme;
  [TextElementType.header1]: TextElementScheme;
  [TextElementType.header2]: TextElementScheme;
  [TextElementType.header3]: TextElementScheme;
  [TextElementType.header4]: TextElementScheme;
  [TextElementType.textLink]: TextElementScheme;
  [TextElementType.mouseoverLink]: TextElementScheme;
}

export class TextElementScheme extends BaseModel {
  [TextElementSchemeKeys.name]: string;
  [TextElementSchemeKeys.fontFamily]: string;
  [TextElementSchemeKeys.fontSize]: number;
  [TextElementSchemeKeys.fontColor]: string;
  [TextElementSchemeKeys.lineHeight]: string;
  [TextElementSchemeKeys.backgroundColor]: string;
  [TextElementSchemeKeys.fontEmphasis]: FontEmphasisType[];
  [TextElementSchemeKeys.underlineStyle]?: UnderlineStyleType;

  constructor(data?: Partial<TextElementScheme>) {
    super();
    this[TextElementSchemeKeys.name] = data?.name || 'Text';
    this[TextElementSchemeKeys.fontFamily] = data?.fontFamily || 'helvetica';
    this[TextElementSchemeKeys.fontSize] = data?.fontSize || 16;
    this[TextElementSchemeKeys.fontColor] = data?.fontColor || '#000000';
    this[TextElementSchemeKeys.lineHeight] = data?.lineHeight || '1.2';
    this[TextElementSchemeKeys.backgroundColor] = data?.backgroundColor || 'transparent';
    this[TextElementSchemeKeys.fontEmphasis] = data?.fontEmphasis || [];
  }
}
